// src/pages/Frota/useResumoAlertas.js — contador de alertas do menu (só ADMIN).
import { useCallback, useEffect, useState } from 'react';
import { getResumoAlertas } from '../../infra/FrotaApi';

const ATUALIZAR_MS = 60_000;
const EVENTO = 'bioailab:alertas-frota-alterados';

/** Avisa o menu que um alerta mudou (ex.: reconhecido), para recontar na hora. */
export const avisarAlertasAlterados = () => window.dispatchEvent(new Event(EVENTO));

/** { abertos, reconhecidos, criticos } ou null. Não busca nada se `ativo` for falso. */
export default function useResumoAlertas(ativo) {
    const [resumo, setResumo] = useState(null);

    const carregar = useCallback(async () => {
        try {
            const r = await getResumoAlertas();
            setResumo(r?.alertas ?? null);
        } catch {
            // Silencioso: o contador some em vez de quebrar o menu.
            setResumo(null);
        }
    }, []);

    useEffect(() => {
        if (!ativo) return undefined;
        carregar();
        const id = setInterval(() => {
            if (document.visibilityState === 'visible') carregar();
        }, ATUALIZAR_MS);
        window.addEventListener(EVENTO, carregar);
        return () => {
            clearInterval(id);
            window.removeEventListener(EVENTO, carregar);
        };
    }, [ativo, carregar]);

    return resumo;
}
